const typography = {
    TinyParagraph: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: 'normal',
    },
    TinyParagraphItalic: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        fontStyle: 'italic',
    },
    TinyParagraphUnderline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textDecoration: 'underline',
    },
    TinyParagraphStrike: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textDecoration: 'line-through',
    },
    TinyParagraphBold: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '12px',
        fontWeight: 700,
        lineHeight: 1.5,
        letterSpacing: 'normal',
    },
    SmallParagraph: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: 1.452,
        letterSpacing: 'normal',
    },
    SmallParagraphItalic: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: 1.452,
        letterSpacing: 'normal',
        fontStyle: 'italic',
    },
    SmallParagraphUnderline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: 1.452,
        letterSpacing: 'normal',
        textDecoration: 'underline',
    },
    SmallParagraphStrike: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: 1.452,
        letterSpacing: 'normal',
        textDecoration: 'line-through',
    },
    SmallParagraphBold: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '14px',
        fontWeight: 700,
        lineHeight: 1.452,
        letterSpacing: 'normal',
    },
    Paragraph: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: 'normal',
    },
    RegularParagraph: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: 'normal',
    },
    RegularParagraphItalic: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        fontStyle: 'italic',
    },
    RegularParagraphUnderline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textDecoration: 'underline',
    },
    RegularParagraphStrike: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textDecoration: 'line-through',
    },
    RegularParagraphBold: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: 1.5,
        letterSpacing: 'normal',
    },
    LargeParagraph: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: 'normal',
    },
    LargeParagraphItalic: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        fontStyle: 'italic',
    },
    LargeParagraphUnderline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textDecoration: 'underline',
    },
    LargeParagraphStrike: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textDecoration: 'line-through',
    },
    LargeParagraphBold: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '20px',
        fontWeight: 700,
        lineHeight: 1.5,
        letterSpacing: 'normal',
    },
    SmallCapsHeadline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '12px',
        fontWeight: 800,
        lineHeight: 1.2,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
    },
    SmallCapsHeadlineExpanded: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '12px',
        fontWeight: 800,
        lineHeight: 1.2,
        letterSpacing: '0.3em',
        textTransform: 'uppercase',
    },
    SuperTinyHeadline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        fontWeight: 800,
        lineHeight: 1.2,
        letterSpacing: 'normal',
    },
    TinyHeadline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '18px',
        fontWeight: 800,
        lineHeight: 1.2,
        letterSpacing: 'normal',
    },
    SmallHeadline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '24px',
        fontWeight: 800,
        lineHeight: 1.2,
        letterSpacing: 'normal',
    },
    Subheadline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '24px',
        fontWeight: 800,
        lineHeight: '26px',
        letterSpacing: 'normal',
    },
    Headline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '36px',
        fontWeight: 800,
        lineHeight: 1.2,
        letterSpacing: '-0.01em',
    },
    MediumHeadline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '36px',
        fontWeight: 800,
        lineHeight: 1.2,
        letterSpacing: '-0.01em',
    },
    RegularHeadline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '32px',
        fontWeight: 800,
        lineHeight: 1.2,
        letterSpacing: '-0.01em',
    },
    SuperHeadline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '48px',
        fontWeight: 800,
        lineHeight: 1.2,
        letterSpacing: '-0.01em',
    },
    HugeHeadline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '64px',
        fontWeight: 900,
        lineHeight: 1.2,
        letterSpacing: '-0.03em',
    },
};
var typography$1 = typography;

export { typography$1 as default };
